import ReactGA from 'react-ga4';
import { useNavigate } from 'react-router-dom';
import { ampli } from '../../../ampli';
import { BottomFloatingButton } from '../../../components/common/buttons/FloatingButtons/BottomFloatingButton';
import { Icon } from '../../../components/common/icon/Icon';

interface SellTractorButtonProps {
  pageType: 'plp' | 'olp' | 'myinfo';
}

// TODO: components로 파일 위치 변경.
export const SellTractorButton = ({ pageType }: SellTractorButtonProps) => {
  const navigate = useNavigate();

  const handleButtonClick = () => {
    ampli.pvmClickSellTractorButton({
      page_type: pageType,
    });
    ReactGA.event('pvm_click_sell_tractor_button', {
      isModal: false,
    });
    navigate('/survey/entry/sell-tractor');
  };

  return (
    <BottomFloatingButton
      handleButtonClick={handleButtonClick}
      icon={<Icon name={'Plus2'} width={20} height={20} />}
      title={'내 농기계 판매'}
    />
  );
};
